import React, { Component } from "react";
import { connect } from "react-redux";
// import { push } from "connected-react-router";
import { Link, withRouter } from "react-router-dom";
import { Form, Input, Button, Row, Col } from "antd";
import { FormattedMessage, injectIntl } from "react-intl";
import messages from "../../utils/commonwords";
import BrokenLink from "../../images/broken-chain.svg";
import { withCookies } from "react-cookie";
import { verifyResetToken, updateUserReset } from "../../store/auth/actions";
const FormItem = Form.Item;

class VerifyReset extends Component {
  componentDidMount() {
    this.props.verifyResetToken(
      this.props.match.params.resetToken,
      this.props.intl,
      this.props.siteLanguage
    );
  }

  confirmPasswordMatch = (rule, value, callback) => {
    if (!value) {
      callback();
    }

    if (value !== this.props.form.getFieldValue("password")) {
      callback("Passwords do not match");
    }

    callback();
  };

  handleSubmit = e => {
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.updateUserReset(
          this.props.intl,
          {
            password: values.password,
            passConfirm: values.cpassword
          },
          this.props.validUser.reset_pass_token,
          this.props.siteLanguage
        );
      }
    });
  };

  render() {
    const {
      form: { getFieldDecorator },
      intl
    } = this.props;
    if (this.props.validx === false) {
      return (
        <div style={{ textAlign: "center" }}>
          <img
            src={BrokenLink}
            alt="broken link"
            width="60"
            style={{ marginBottom: "1rem" }}
          />
          <p style={{ fontSize: "24px" }}>
            <FormattedMessage
              defaultMessage=" Password reset request expired"
              id="App.Text.PWordlinkExpired"
            />
          </p>
          <div className="auth_form_links">
            <p style={{ paddingTop: "10%" }}>
              <Link
                data-dfs-people-id={"signin-link"}
                to={`/${this.props.siteLanguage || "en"}/forgotten-password`}
              >
                <FormattedMessage
                  id="resetPassword.resetRequestMsg"
                  defaultMessage={"Request New Password Reset Or Token"}
                />
              </Link>
            </p>
          </div>
        </div>
      );
    } else {
      return (
        <Form
          onSubmit={this.handleSubmit}
          className="resetPassword"
          hideRequiredMark
        >
          <Row gutter={16}>
            <Col span={24}>
              <FormItem
                data-dfs-people-id={"password"}
                colon={false}
                label={
                  <FormattedMessage
                    id="loginForm.PasswordInput"
                    defaultMessage={"New Password"}
                  />
                }
              >
                {getFieldDecorator("password", {
                  rules: [
                    {
                      required: true,
                      message: intl.formatMessage(
                        messages.formErrorMsgInputPassword
                      )
                    },
                    {
                      min: 6,
                      message: intl.formatMessage(messages.minPasswordChar)
                    }
                  ]
                })(<Input size="large" type="password" placeholder="" />)}
              </FormItem>
            </Col>
            <Col span={24}>
              <FormItem
                data-dfs-people-id={"confirm-password"}
                colon={false}
                label={
                  <FormattedMessage
                    id="loginForm.ConfirmPasswordInput"
                    defaultMessage={"Confirm New Password"}
                  />
                }
              >
                {getFieldDecorator("cpassword", {
                  rules: [
                    {
                      required: true,
                      message: intl.formatMessage(
                        messages.formErrorMsgConfirmPassword
                      )
                    },
                    { validator: this.confirmPasswordMatch },
                    {
                      min: 6,
                      message: intl.formatMessage(messages.minPasswordChar)
                    }
                  ]
                })(<Input size="large" type="password" placeholder="" />)}
              </FormItem>
            </Col>
          </Row>
          <div style={{ marginTop: ".7rem", marginBottom: "1rem" }}>
            <Button
              data-dfs-people-id={"reset-button"}
              block
              type="primary"
              size="large"
              htmlType="submit"
              className="reset-form-button"
              loading={this.props.loading}
            >
              <FormattedMessage
                id="resetPassword.ResetButton"
                defaultMessage={"Reset Password"}
              />
            </Button>
          </div>
          <div className="auth_form_links">
            <p style={{ paddingTop: "10%" }}>
              <FormattedMessage
                id="loginScreen.HaveAccountText"
                defaultMessage={"Already have an account?"}
              />{" "}
              <Link
                data-dfs-people-id={"signin-link"}
                to={`/${this.props.siteLanguage || "en"}/signin`}
              >
                <FormattedMessage
                  id="App.Text.Signin"
                  defaultMessage={"Sign in"}
                />
              </Link>
            </p>
          </div>
        </Form>
      );
    }
  }
}

const mapStateToProps = state => {
  return {
    siteLanguage: state.intl.siteLanguage,

    validx: state.auth.validx,
    validating: state.auth.validating,
    validUser: state.auth.validUser
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    verifyResetToken: (token, intl, siteLanguage) => {
      dispatch(verifyResetToken(token, intl, siteLanguage));
    },
    updateUserReset: (intl, userData, resetToken, siteLanguage) => {
      dispatch(updateUserReset(intl, userData, resetToken, siteLanguage));
    }
  };
};

const VerifyResetForm = Form.create()(VerifyReset);

export default injectIntl(
  withCookies(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(withRouter(VerifyResetForm))
  )
);